import { PoisState } from '../../../../@types';

const initialState: PoisState = [];
export default initialState;
